import * as React from 'react';
import useTablePage from '../hooks/useTablePage';
import { createUser } from '../api/users';
import AddContactWizard from '../forms/AddContactWizard';

const PermitAddContact = ({
  setAddContactModal,
  setModalTitle,
}: Props) => {
  const {
    createOrUpdate,
    modalErrorTitle,
    errors,
    isApiSuccess,
  } = useTablePage({
    createEndpoint: createUser,
    modalCreateTitle: 'Add Individual',
  });

  React.useEffect(() => {
    if (isApiSuccess) {
      setAddContactModal(false);
    }
  }, [isApiSuccess]);

  return (
    <AddContactWizard
      modalError={modalErrorTitle.length > 0}
      initialErrors={errors}
      onSubmit={createOrUpdate}
      setModalTitle={setModalTitle}
    />
  );
};

interface Props {
  setIsContactFormSubmitting?: (data) => void;
  setAddContactModal?: (data: boolean) => void;
  setModalTitle?: (title: string) => void;
}

export default PermitAddContact;
